<script setup lang="ts">
import type { PdpInfoReturnItemProps } from './PdpInfoReturnItem.props'

const props = defineProps<PdpInfoReturnItemProps>()
const { isDialogOpen } = useDialog(props.sidebarId)

const { data: infoShippingContent, execute } =
  await useInfosWithTitleItem('info-free-return')
watch(isDialogOpen, async value => {
  if (value) {
    await execute()
  }
})
</script>
<template>
  <OrganismsSidebarSlide
    :id="props.sidebarId"
    :header-props="{
      titleText: infoShippingContent?.content?.title ?? '',
      hasBackButton: hasBackButton,
      hasCloseButton: !hasBackButton,
    }"
    :is-alpha-layer-transparent="isAlphaLayerTransparent"
  >
    <template #body>
      <div class="flex flex-col gap-y-2">
        <UtilsMarkdown
          v-if="infoShippingContent?.content?.body"
          :content="infoShippingContent?.content?.body"
          class="text-light-6 mb-2"
          container="h3"
        />
      </div>
    </template>
  </OrganismsSidebarSlide>
</template>
